import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-radiobuttons',
  templateUrl: './radiobuttons.component.html',
  styleUrls: ['./radiobuttons.component.scss']
})
export class RadiobuttonsComponent implements OnInit {
  arrayComponent: any;
  componentRender: any;
  infoComponent: any;
  constructor() {

    this.arrayComponent = [
      {
        id: 'radio',
        titulo: 'Input radio sin opción seleccionada',
        subtitulo: `Input type <code>radio</code> sin ninguna opción seleccionada de forma predeterminada.
        `,
        componentRender:
          `<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioSimple" id="exampleRadio1" value="opcion1" />
    <label for="exampleRadio1">1. Primera opción</label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioSimple" id="exampleRadio2" value="opcion2" />
    <label for="exampleRadio2">2. Segunda opción</label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioSimple" id="exampleRadio3" value="opcion3"/>
    <label for="exampleRadio3">3. Tercera opción </label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioSimple" id="exampleRadio4" value="opcion4" />
    <label for="exampleRadio4">4. Cuarta opción </label>
</label>
`,
      },
      {
        id: 'predeterminado',
        titulo: 'Input radio con opción predeterminada',
        subtitulo: `Input type <code>radio</code> con opción predeterminada. A la etiqueta input se añade el atributo 
        <code>checked</code> o <code>checked="true"</code> a la opción que queremos seleccionar como predeterminada.
        `,
        componentRender:
          `<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioDefault" id="exampleRadioDefault1" value="opcion1" />
    <label for="exampleRadioDefault1">1. Primera opción</label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioDefault" id="exampleRadioDefault2" value="opcion2" checked/>
    <label for="exampleRadioDefault2">2. Segunda opción (Predeterminada)</label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioDefault" id="exampleRadioDefault3" value="opcion3"/>
    <label for="exampleRadioDefault3">3. Tercera opción </label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioDefault" id="exampleRadioDefault4" value="opcion4" />
    <label for="exampleRadioDefault4">4. Cuarta opción </label>
</label>
`,
      },
      {
        id: 'disabled',
        titulo: 'Input radio con opción deshabilitada',
        subtitulo: `
        Input type <code>radio</code>, con opción deshabilitada. 
        A la etiqueta input se añade el atributo <code>disabled</code> o <code>disabled="true"</code>. `,
        componentRender:
`<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioDisabled" id="exampleRadioDisabled1" value="opcion1" />
    <label for="exampleRadioDisabled1">1. Primera opción</label>
</label>
<label class="radiolist-govco radiobutton-govco disabled">
    <input type="radio" name="exampleRadioDisabled" id="exampleRadioDisabled2" value="opcion2" disabled="true" checked/>
    <label for="exampleRadioDisabled2">2. Segunda opción (Deshabilitada y predeterminada)</label>
</label>
<label class="radiolist-govco radiobutton-govco disabled">
    <input type="radio" name="exampleRadioDisabled" id="exampleRadioDisabled3" value="opcion3" disabled="true"/>
    <label for="exampleRadioDisabled3">3. Tercera opción (Deshabilitada)</label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioDisabled" id="exampleRadioDisabled4" value="opcion4" />
    <label for="exampleRadioDisabled4">4. Cuarta opción </label>
</label>
`,
      },
      {
        id: 'invalida',
        titulo: 'Input radio con opción no válida',
        subtitulo: `Si desea presentar una opción no válida o con algún error, puede usar la clase  
        <code>class="error"</code>en la etiqueta contenedora label`,
        componentRender:
`<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioError" id="exampleRadioError1" value="opcion1" />
    <label for="exampleRadioError1">1. Primera opción</label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioError" id="exampleRadioError2" value="opcion2"/>
    <label for="exampleRadioError2">2. Segunda opción</label>
</label>
<label class="radiolist-govco radiobutton-govco">
    <input type="radio" name="exampleRadioError" id="exampleRadioError3" value="opcion3"/>
    <label for="exampleRadioError3">3. Tercera opción</label>
</label>
<label class="radiolist-govco radiobutton-govco error">
    <input type="radio" name="exampleRadioError" id="exampleRadioError4" value="opcion4" />
    <label for="exampleRadioError4">4. Cuarta opción (con un error)</label>
</label>
`,
      },
    ];

    this.infoComponent = {
      titulo: "Lista de chequeo Radio",
      descripcion: "",
    }

  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    // this.componentRender = this.exampleInput.nativeElement.innerHTML;
    // this.exampleInput.nativeElement.innerHTML = ""; 
  }
}